import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api, { getErrorMessage } from '../../services/api';
import { PARTNER_SETTABLE_STATES, EXPEDIENT_STATUSES } from '@claimup/shared/constants/expedient';
import { PROCEDURE_KIND_LABELS } from '@claimup/shared/helpers/judicial-pricing';

/**
 * Selector de estado del despacho colaborador (docs/partners-plan.md, D5). Solo
 * ofrece estados de la vía judicial: sacar el expediente de judicial lo decide
 * ClaimUp. El backend lo vuelve a comprobar (`POST /expedients/:id/estado`).
 */
function PartnerStateSelect({ expedientId, estado, onChange }) {
  const [saving, setSaving] = useState(false);
  // Al pasar a «Demanda presentada» se pide qué procedimiento es: con eso se
  // factura la demanda (docs/precios-judicial-plan.md). Se puede dejar sin indicar.
  const [pendiente, setPendiente] = useState(false);
  const [tipo, setTipo] = useState('');

  const options = PARTNER_SETTABLE_STATES.includes(estado)
    ? PARTNER_SETTABLE_STATES
    : [estado, ...PARTNER_SETTABLE_STATES].filter(Boolean);

  const enviar = async (next, procedimiento) => {
    setSaving(true);
    try {
      const { data } = await api.post(`/expedients/${expedientId}/estado`, {
        estado: next,
        ...(procedimiento ? { procedimiento } : {}),
      });
      onChange(data.data.estado, procedimiento || null);
      toast.success('Estado actualizado');
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setSaving(false);
      setPendiente(false);
      setTipo('');
    }
  };

  const handleChange = e => {
    const next = e.target.value;
    if (next === estado) return;
    if (next === EXPEDIENT_STATUSES.DEMANDA_PRESENTADA) {
      setPendiente(true);
      return;
    }
    enviar(next);
  };

  if (pendiente) {
    return (
      <div className='inline-flex flex-wrap items-center gap-2 text-sm text-gray-600'>
        <span className='font-medium'>Demanda presentada:</span>
        <select
          aria-label='Tipo de procedimiento'
          className='rounded-lg border-gray-300 text-sm'
          value={tipo}
          onChange={e => setTipo(e.target.value)}
        >
          <option value=''>Sin indicar</option>
          {Object.entries(PROCEDURE_KIND_LABELS).map(([v, l]) => (
            <option key={v} value={v}>
              {l}
            </option>
          ))}
        </select>
        <button
          type='button'
          disabled={saving}
          onClick={() => enviar(EXPEDIENT_STATUSES.DEMANDA_PRESENTADA, tipo ? { kind: tipo } : null)}
          className='rounded-lg bg-blue-600 px-3 py-1 text-white disabled:opacity-50'
        >
          Confirmar
        </button>
        <button type='button' onClick={() => setPendiente(false)} className='text-gray-500 hover:underline'>
          Cancelar
        </button>
      </div>
    );
  }

  return (
    <label className='inline-flex items-center gap-2 text-sm text-gray-600'>
      <span className='font-medium'>Estado</span>
      <select
        className='rounded-lg border-gray-300 text-sm focus:ring-blue-500 focus:border-blue-500'
        value={estado || ''}
        onChange={handleChange}
        disabled={saving}
      >
        {options.map(s => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>
    </label>
  );
}

export default PartnerStateSelect;
